<template>
  <div class="feed-back-wrap">
    <div class="feed-back-card">
      <div class="title">常见问题</div>
      <el-form autoComplete="on" :model="form" size="large" v-loading="loading" :rules="formRules"
        element-loading-text="给我一点时间" label-position="left" ref="form" label-width="120px" label-suffix="：">
        <div class="form-wrap my-form">
          <div class="form-item">
            <el-form-item label="问题类型" prop="type">
              <el-radio-group v-model="form.type" text-color="#00b4e8">
                <el-radio :label="0">服务反馈</el-radio>
                <el-radio :label="1">BUG反馈</el-radio>
                <el-radio :label="2">意见反馈</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="form-item">
            <el-form-item label="问题描述" prop="content">
              <el-input style="width:450px" type="textarea" :autosize="{ minRows: 3, maxRows: 6 }"
                v-model="form.content" placeholder="请输入问题描述">
              </el-input>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="submit" class="my-btn" :loading="loading" @click="handleSubmit">
              提交
            </el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { feedback } from "@/api/user";
export default {
  name: 'UserFeedback',
  components: {

  },
  data() {
    return {
      loading: false,
      form: {
        type: 0,
        content: ''
      },
      formRules: {
        content: [
          { required: true, message: "请输入内容", trigger: "blur" },
        ],
      },
    };
  },
  computed: {

  },
  created() {

  },
  methods: {
    // 提交信息
    handleSubmit() {
      // 验证form表单
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          const _form = JSON.parse(JSON.stringify(this.form))
          feedback(_form).then((response) => {
            this.loading = false;
            // 弹出操作提示
            this.$message({
              type: 'success',
              message: '提交成功!'
            });
            this.getIdentityPreview();
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.feed-back-wrap {
  width: 100%;

  .el-radio-group {
    display: flex;
  }

  .feed-back-card {
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 1px rgba(111, 127, 132, 0.102);
    border-radius: 2px;
    margin-top: 16px;
    padding-bottom: 70px;

    .title {
      width: 100%;
      border-bottom: 1px solid #CCD7DB;
      padding: 29px 0;
      font-size: 16px;
      font-weight: bold;
      color: #222222;
      text-align: center;
    }

    .form-wrap {
      padding-top: 40px;
      width: 50%;
      margin: 0 auto;

      .form-item {
        grid-template-columns: 2fr 8fr;
      }
    }
  }
}
</style>
